import { yupResolver } from '@hookform/resolvers/yup';
import { enqueueSnackbar } from 'notistack';
import React, { useEffect, useState } from 'react';
import { Resolver, useForm } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { useNavigate, useParams } from 'react-router-dom';
import { handleError } from '../../../shared/functions/handleError';
import { IDepartment } from '../../../shared/interfaces/department/IDepartment';
import { IProject } from '../../../shared/interfaces/projects/IProject';
import { ISkill, IUser } from '../../../shared/interfaces/user/IUser';
import { userSchema } from '../../admin/employees/components/EmployeeUpdate';
import EmployeeTabs from '../../admin/employees/components/tabs/EmployeeTabs';
import { AdminEmployeeService } from '../../admin/employees/service';
import { UserEmployeeService } from './service';

const UserEmployeesUpdate = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const { t } = useTranslation();
  const {
    handleSubmit,
    control,
    reset,
    watch,
    formState: { errors },
  } = useForm<IUser>({
    resolver: yupResolver(userSchema) as unknown as Resolver<IUser>,
  });
  const [file, setFile] = useState<File | null>(null);
  const [files, setFiles] = useState<FileList | null>(null);
  const [isLoading, setIsLoading] = useState(false);

  const submitHandler = async (state: IUser) => {
    const formData = new FormData();
    formData.append('body', JSON.stringify(state));
    if (file) {
      formData.append('file', file);
    }
    if (files) {
      for (const file of files as unknown as []) {
        formData.append('files', file);
      }
    }
    setIsLoading(true);
    await UserEmployeeService.update(formData, state?.id)
      .then((response) => {
        if (response) {
          navigate('/user/employees');
          enqueueSnackbar(
            t('toasts.successfullyUpdated', { title: response?.displayName }),
            { variant: 'success' },
          );
        }
      })
      .catch(handleError)
      .finally(() => setIsLoading(false));
  };

  useEffect(() => {
    if (id) {
      AdminEmployeeService.getSingle(Number(id))
        .then((response) => {
          reset({
            ...response,
            projects: response?.projects?.map(
              (project: IProject) => project.id,
            ),
            departments: response?.departments?.map(
              (department: IDepartment) => department.id,
            ),
            skills: response?.skills?.map((skill: ISkill) => skill.id),
          });
        })
        .catch(handleError);
    }
  }, [id, reset]);
  return (
    <form onSubmit={handleSubmit(submitHandler)}>
      <EmployeeTabs
        isLoading={isLoading}
        control={control}
        isUpdate
        errors={Object.keys(errors)}
        watch={watch}
        file={file}
        setFile={setFile}
        files={files}
        setFiles={setFiles}
      />
    </form>
  );
};

export default UserEmployeesUpdate;
